import moment from "moment";
import { CONSTANTS } from "./constants";

export const getResponse = (data) => {
    return {
        loading: true,
        status: "SUCCESS",
        data
    };
};

export const getErrorResponse = (error) => {
    if(error?.body) {
        return {
            loading: true,
            status: "FAILED",
            error: error.body,
            message: error.body?.message || null
        };    
    }
    let errors = [{ errorMessage: error }];
    return {
        loading: true,
        status: "PRECONDITION_FAILED",
        error,
        errors,
        message: null,
        token: null,
        payload: null
    };
};

export const allQuoteOptionsExpired = (quote) => {
    return quote?.quoteOptions?.filter(option => option.noOfDaysToExpire !== 0)?.length === 0;
};

export const getManualQuoteStartDate = () => {
    return moment().add(1, "days").add(8, "months").format("YYYY-MM-DD");
};

export const getMarkupObject = (markupType) => {
    let _markupType = markupType || CONSTANTS.MARKUP_TYPE_PERCENT;
    return {
        type: _markupType,
        adult: undefined,
        child: undefined
    };
};